import { Component, OnInit, Input } from '@angular/core';
import { ColetaService } from '../coleta.service';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { ResultadoInconsistencia } from '../../comum/modelos/resultado-inconsistencia';
import { Inconsistencia } from '../../comum/modelos/inconsistencia';

@Component({
    selector: 'app-lista-inconsistencias',
    templateUrl: './lista-inconsistencias.component.html',
    styleUrls: ['./lista-inconsistencias.component.css']
})
export class ListaInconsistenciasComponent implements OnInit {

    @Input() resultadoInconsistencia: ResultadoInconsistencia;

    inconsistencias: Inconsistencia[];
    statusCode: number;
    public paginacao: Paginacao;
    public evento: Evento;

    public loading = false;

    constructor (
        private _coletaService: ColetaService,
        private _comumService: ComumService) {
        this.inconsistencias = new Array<Inconsistencia>();
        this.paginacao = new Paginacao();
        this.evento = this._comumService.evento;
        this.loading = false;
        if (this.evento !== undefined) {
            setTimeout(() => {
                this._comumService.cleanEvent();
            }, 2000);
        }
    }

    ngOnInit() {
        this.paginacao.itens = 5;
        this.paginacao.page = 1;
        this.loading = true;
        const result = this.resultadoInconsistencia;
        this._coletaService.obterInconsistenciasHttp(result).subscribe(inconsistencias => {
            this.inconsistencias = inconsistencias.body;
            this.loading = false;
        });
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/coleta/lista-inconsistencias/lista-inconsistencias.component.ts